import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import { Button } from '../Button';
import { withStyles } from '@material-ui/core/styles';
import { Rating } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StarRateIcon from '@mui/icons-material/StarRate';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { PlayerAvatar } from '../PlayerAvatar';
import trophy from '../../assets/images/step-4.png';

interface IModalContact {
  modalIsOpen: boolean;
  player: any;
  toggleModal: () => void;
  companyName?: string;
  isAutoIndicate?: boolean;
  customText?: string;
  postRating?: any;
  actionMgm?: string;
  actionMgmCta?: string;
  actionMgmRedirect?: string;
  showEvaluation?: string;
  /** Se informado, o botão de cadastro abre o chat em vez de ir para a tela de cadastro. */
  onRegisterWithAi?: () => void;
}

const StyledRating = withStyles({
  iconFilled: {
    color: '#ffc107',
  },
})(Rating);

export function ModalContact({
  modalIsOpen,
  player,
  toggleModal,
  companyName,
  isAutoIndicate,
  customText,
  postRating,
  actionMgm,
  actionMgmCta,
  actionMgmRedirect,
  showEvaluation,
  onRegisterWithAi,
}: IModalContact) {
  const navigate = useNavigate();
  const [voted, setVoted] = useState(false);

  useEffect(() => {
    if (modalIsOpen) {
      setVoted(false);
    }
  }, [modalIsOpen]);

  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <PlayerAvatar
            photoURL={player?.photoURL}
            size={70}
            style={{ overflow: 'hidden' }}
          />
        </div>
        <h1 className={styles.title}>Obrigado(a)</h1>
        {companyName === 'Renda Mais Vivaz' && (
          <p className={styles.subtitle}>
            Em breve você receberá uma mensagem do nosso Whatsapp para confirmar
            a indicação! Fique de olho e boa sorte na compra do seu Apê!
          </p>
        )}
        {companyName !== 'Renda Mais Vivaz' && (
          <>
            {!isAutoIndicate && (
              <p className={styles.subtitle}>Em breve entraremos em contato!</p>
            )}
            {customText && <p className={styles.subtitle}>{customText}</p>}
          </>
        )}
        {showEvaluation === 'true' && (
          <>
            <p className={`${styles.subtitle} fw-bold`}>
              Avalie a indicação de {player && player.name}
            </p>
            <div className="d-flex justify-content-center">
              <StyledRating
                defaultValue={null}
                precision={0.5}
                onChange={(e, newValue) => {
                  postRating(newValue);
                  setVoted(true);
                }}
                icon={
                  <StarRateIcon
                    style={{ width: '32px', height: '32px' }}
                  ></StarRateIcon>
                }
                emptyIcon={
                  <StarOutlineIcon
                    style={{ width: '32px', height: '32px' }}
                  ></StarOutlineIcon>
                }
                disabled={voted}
              />
            </div>
            {voted && (
              <p className={styles.modal}>Obrigado por sua avaliação!</p>
            )}
          </>
        )}

        {actionMgm && actionMgm === 'true' && player.regional === 'nao' && (
          <div className="d-flex align-items-center text flex-column mt-3">
            <p className={`${styles.subtitle} fw-bold`}>
              Quer ganhar prêmio indicando a {companyName} para amigos?
            </p>
            <img
              className="rounded rounded-circle"
              src={trophy}
              alt="Troféu"
              width={70}
            />
          </div>
        )}
      </div>
      <div className={styles.contentBtn}>
        {actionMgm && actionMgm === 'true' && player.regional === 'nao' && (
          <Button
            isModal
            text="Não obrigado(a)"
            type="button"
            color="flat"
            onClick={toggleModal}
          />
        )}
        <Button
          isModal
          text={
            actionMgm && actionMgmCta && player.regional === 'nao'
              ? actionMgmCta
              : 'Concluir'
          }
          type="button"
          color="primary"
          onClick={() => {
            if (actionMgm && player.regional === 'nao') {
              if (onRegisterWithAi) {
                toggleModal();
                onRegisterWithAi();
              } else {
                navigate(actionMgmRedirect);
              }
            } else {
              toggleModal();
            }
          }}
        />
      </div>
    </Modal>
  );
}
